import { useParams } from "react-router-dom";
import { useGetFormByIdQuery } from "../store/topicApi";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import type { Components } from "react-markdown";
import React from "react";

interface CodeProps extends React.HTMLAttributes<HTMLElement> {
  inline?: boolean;
}

const mdComponents: Components = {
  a({ node, children, ...props }) {
    return (
      <a {...props} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  },
  code({ inline, className, children, ...props }: CodeProps) {
    if (inline) {
      return (
        <code
          className="px-1 py-0.5 rounded bg-zinc-100 dark:bg-zinc-800"
          {...props}
        >
          {children}
        </code>
      );
    }
    return (
      <pre className="p-4 overflow-x-auto text-sm">
        <code className={className} {...props}>
          {children}
        </code>
      </pre>
    );
  },
};

const ViewBlog = () => {
  const { id } = useParams<{ id: string }>();
  const { data: form, isLoading, isError } = useGetFormByIdQuery(id!);

  if (isLoading) return <div>Loading...</div>;
  if (isError || !form) return <div>Error loading blog content.</div>;

  return (
    <div className="max-w-4xl mx-auto p-4 md:p-6">
      Edit
      <h1 className="text-3xl md:text-4xl font-bold mb-4">{form.title}</h1>
      <article className="prose prose-zinc lg:prose-xl max-w-none dark:prose-invert prose-pre:rounded-2xl prose-pre:shadow">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeHighlight]}
          components={mdComponents}
        >
          {form.blog ?? ""}
        </ReactMarkdown>
      </article>
    </div>
  );
};

export default ViewBlog;
